export function getCaretCoordinates(
  element: HTMLTextAreaElement,
  position: number
): DOMRect {
  const div = document.createElement("div");
  const style = div.style;
  const computed = window.getComputedStyle(element);

  // Copy basic styles
  style.whiteSpace = "pre-wrap";
  style.wordWrap = "break-word";
  style.position = "absolute";
  style.visibility = "hidden";
  style.pointerEvents = "none";
  style.left = "-9999px";
  style.top = "0";

  // Transfer all text-affecting styles from the textarea to the dummy div
  const properties = [
    "direction",
    "boxSizing",
    "width",
    "height",
    "overflowX",
    "overflowY",
    "borderTopWidth",
    "borderRightWidth",
    "borderBottomWidth",
    "borderLeftWidth",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "fontStretch",
    "fontSize",
    "fontSizeAdjust",
    "lineHeight",
    "fontFamily",
    "textAlign",
    "textTransform",
    "textIndent",
    "textDecoration",
    "letterSpacing",
    "wordSpacing",
    "tabSize",
    "MozTabSize",
  ];

  properties.forEach((prop) => {
    (style as any)[prop] = (computed as any)[prop];
  });

  // Put text up to the caret position in the div
  div.textContent = element.value.substring(0, position);

  // The span is the marker we'll measure
  const span = document.createElement("span");
  // Give it a non-empty string so it has height
  span.textContent = element.value.substring(position) || ".";
  div.appendChild(span);

  document.body.appendChild(div);

  const { offsetTop, offsetLeft } = span;
  const { top, left } = element.getBoundingClientRect();

  // Account for textarea scroll position
  const x = left + offsetLeft - element.scrollLeft;
  const y = top + offsetTop - element.scrollTop;
  const height = parseInt(computed.lineHeight) || parseInt(computed.fontSize);

  document.body.removeChild(div);

  return new DOMRect(x, y, 0, height);
}
